import { render, staticRenderFns } from "./EditLocationComponent.vue?vue&type=template&id=238740c9&"
import script from "./EditLocationComponent.vue?vue&type=script&lang=js&"
export * from "./EditLocationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports